const transformLogoUrl = (url, size = 200) => {
  if (!url) return url;

  try {
    const parsed = new URL(url);
    let id;

    if (parsed.hostname === 'drive.usercontent.google.com') {
      id = parsed.searchParams.get('id');
    } else if (parsed.hostname === 'drive.google.com') {
      const fileMatch = parsed.pathname.match(/\/file\/d\/([^/]+)/);
      id = fileMatch?.[1] || parsed.searchParams.get('id');
    }

    if (id) {
      return `https://drive.google.com/thumbnail?id=${id}&sz=w${size}`;
    }
  } catch {
    // Invalid URL — return as-is
  }

  return url;
};

export default transformLogoUrl;
